import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>Page Not Found | DH Cleaning Services</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to DH Cleaning Services homepage." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="flex min-h-screen items-center justify-center bg-muted">
        <div className="text-center px-6">
          <p className="text-8xl font-display font-bold text-primary mb-4">404</p>
          <h1 className="text-2xl font-display font-bold text-foreground mb-2">Page Not Found</h1>
          <p className="text-muted-foreground mb-8 max-w-md mx-auto">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Button asChild>
              <Link to="/"><Home className="mr-1.5 h-4 w-4" /> Back to Home</Link>
            </Button>
            <Button variant="outline" asChild>
              <Link to="/contact"><ArrowLeft className="mr-1.5 h-4 w-4" /> Contact Us</Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
